import Image from 'next/image'
import { cn } from '@/utils/twMerge'
import { PrismicRichText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'

type DataObject = Record<string, any>

const SocialProofReview = ({ item, uid }: { item: DataObject; uid?: string }) => {
  return (
    <div className="flex h-full flex-col">
      <div className="mb-4 flex flex-none gap-1">
        {Array.from({ length: 5 }, (_, index) => {
          const key = `i-${index}`
          return <Image src="/images/Star.svg" width={20} height={20} alt="" key={key} aria-hidden="true" />
        })}
      </div>

      <div className="flex-none">
        <PrismicRichText
          field={item.title}
          components={{
            heading3: ({ children }) => <h3 className={cn(uid === 'request-cmmc-demo' && 'text-white')}>{children}</h3>,
          }}
        />
      </div>

      <div className="flex-grow [&>p]:mt-5 [&>p]:text-[22px] [&>p]:leading-[30px]">
        <PrismicRichText
          field={item.description}
          components={{
            paragraph: ({ children }) => (
              <p className={cn(uid === 'request-cmmc-demo' && 'text-white/80')}>{children}</p>
            ),
          }}
        />
      </div>

      <div className="mt-4 flex flex-none gap-4">
        <PrismicNextImage field={item.client_logo} height={46} width={46} className="rounded-full" fallbackAlt="" />
        <div className="flex flex-col justify-center">
          <span className={cn('block font-halyardDisplay text-base', uid === 'request-cmmc-demo' && 'text-white/60')}>
            {item.client_name}
          </span>
          <span
            className={cn(
              'block font-halyardText text-sm',
              uid === 'request-cmmc-demo' ? 'text-white/60' : 'text-primary-ink-60',
            )}>{`${item?.client_designation ?? ''} ${item?.client_organization ?? ''}`}</span>
        </div>
      </div>
    </div>
  )
}

export default SocialProofReview
